<div class="wrapper" style="">
    <p class="p-first">
        GOT A QUESTION?
    </p>

    <h2 class="h2-first">
        Contact Bizdata

    </h2>

    We’re here to help and answer any question you might have. We look forward to hearing from you 🙂

    <div class="contact-card-container">
        <div>
            <div>
                <div class="our-team">
                    <div class="picture">
                        <img class="img-fluid" src="assets/images/logo.jpg" alt="company logo">
                    </div>
                    <div class="team-content">
                        <h3 class="name">You can find us on</h3>
                        <p>
                            Phone Number : +1-650-283-1644
                        </p>
                        <p>
                            Email Address : info@bizdata360.com
                        </p>
                    </div>
                    <ul class="social">
                        <li><a href="https://www.facebook.com/bizdata360/" class="fa fa-facebook"
                                aria-hidden="true"></a></li>
                        <li><a href="https://twitter.com/bizdata360" class="fa fa-twitter" aria-hidden="true"></a></li>
                        <li><a href="https://www.youtube.com/channel/UC0k1Y7PhsdLBWzyAjr6U-hA" class="fa fa-youtube"
                                aria-hidden="true"></a></li>
                        <li><a href="https://www.linkedin.com/company/bizdata-inc/" class="fa fa-linkedin"
                                aria-hidden="true"></a></li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</div>
